import { Injectable } from '@angular/core';
import { AuthenticationService } from 'app/shared/service/authentication.service';
import { SharedService } from 'app/shared/service/shared.service';
import { MenuAccessDetail } from 'shared/service-proxies/models/menu-access-detail.model';
import { Roles } from '../constants/roles.constant';
@Injectable({
    providedIn: 'root'
})
export class NavigateRightService {

    roleName: any;
    roleId: number;
    constructor(
        private _sharedService: SharedService,
        private _authenticationService: AuthenticationService,

    ) {
    }


    canViewParent(parentmenuName: string): any | boolean {
        var canparentView = this._authenticationService.isAdministrator();
        if (!this._authenticationService.isAdministrator()) {
            if (this._sharedService.menuAccessWright != null) {
                this._sharedService.menuAccessWright.forEach(a => {
                    if (a.parentMenuName == parentmenuName) {
                        if (a.menuDetails != null) {
                            a.menuDetails.forEach(z => {
                                if (z.menuAccessDetail.canAccess == true)
                                    canparentView = true
                            })
                        }

                    }
                })
            }
        }
        return canparentView;
    }
    canView(menuname: string): any | boolean {
        var canView = this._authenticationService.isAdministrator();
        var clarify = this._sharedService.isClarify() as any;
        if (!this._authenticationService.isAdministrator()) {
            if (this._sharedService.menuAccessWright != null) {
                this._sharedService.menuAccessWright.forEach(a => {
                    if (a.menuDetails != null) {
                        a.menuDetails.forEach(z => {
                            if (z.menuName == menuname){
                                canView = z.menuAccessDetail.canAccess;
                                if(menuname == "Clarification Application" && z.menuAccessDetail.canAccess) {
                                    canView = clarify;
                                }
                            }
                        })
                    }
                })
            }
        }
        return canView;
    }
    menuRights(menuname: string): any | MenuAccessDetail {
        let companyID = this._authenticationService.CurrentUserCompanyId()
        var menuAccessDetail = new MenuAccessDetail();
        menuAccessDetail.canAdd = !isNaN(Number(companyID)) && this._authenticationService.isAdministrator();
        menuAccessDetail.canDelete = !isNaN(Number(companyID)) && this._authenticationService.isAdministrator();
        menuAccessDetail.canEdit = !isNaN(Number(companyID)) && this._authenticationService.isAdministrator();


        if (!isNaN(Number(companyID)) && !this._authenticationService.isAdministrator()) {
            if (this._sharedService.menuAccessWright != null) {
                this._sharedService.menuAccessWright.forEach(a => {
                    if (a.menuDetails != null) {
                        a.menuDetails.forEach(z => {
                            if (z.menuName == menuname)
                                menuAccessDetail = z.menuAccessDetail;
                        })
                    }
                })
            }

        }
        return menuAccessDetail;
    }

}